var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-screen',{attrs:{"icon":"note","message":"Select a note"}})}
var staticRenderFns = []

export { render, staticRenderFns }